import { endpoints, getDatabaseData } from './index';

const getAllMedia = async () => {
  const response = await getDatabaseData(endpoints.MEDIA).then(data => data);

  return response;
};

export default { getAllMedia };



// WEBPACK FOOTER //
// ./src/api/media.js